var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:(_vm.badgeStyles)},[_vm._t("default"),_vm._ssrNode(" "),_vm._ssrNode("<span"+(_vm._ssrClass(null,_vm.badgeClasses))+(_vm._ssrStyle(null,_vm.backgroundColorStyle, null))+">","</span>",[_vm._t("label",[_vm._v(_vm._s(_vm.label))])],2)],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67e4703c","hasScoped":false,"optionsId":"1","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/badge/badge.vue
// module id = 705
// module chunks = 0 1 49